<template>
  <!-- 病症标签 -->
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getLabelList)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="标签名称">
            <el-input v-model="searchForm.pathologyLabelName" placeholder="请输入标签名称" />
          </el-form-item>
          <el-form-item label="标签科室">
            <el-select v-model="searchForm.postId" placeholder="请选择所属科室">
              <el-option v-for="item in postList" :key="item.postId" :value="item.postId" :label="item.postName" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getLabelList, true)">查询</el-button>
            <el-button icon="el-icon-refresh"
              @click="$reset(getLabelList, { pathologyLabelName: null, postId: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addLabel">新增标签</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="deleteLabelList">批量删除</el-button>
      </div>
      <div>
        <!-- 标签列表 -->
        <el-table v-loading="loading" :data="maladyLabelList" ref="multipleTable" :max-height="tableHeight"
          @selection-change="val => $handleSelectionChange(val, true)" border>
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column type="index" label="序号" width="50" />
          <el-table-column prop="pathologyLabelName" label="标签名称" />
          <el-table-column prop="postName" label="标签科室" />
          <el-table-column prop="createTime" label="创建时间" min-width="150" />
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" type="primary" @click="editLabel(scope.row)">编辑</el-button>
              <el-button icon="el-icon-delete" type="danger" @click="deleteLabel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination class="mt20" @current-change="page => $handleCurrentChange(page, getLabelList)" :total="total"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
      </div>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="350px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="标签名称" prop="pathologyLabelName">
            <el-input v-model="editForm.pathologyLabelName" placeholder="请输入标签名称" />
          </el-form-item>
          <el-form-item label="标签类型" prop="postId">
            <el-select v-model="editForm.postId" placeholder="请选择标签所属科室">
              <el-option v-for="item in postList" :key="item.postId" :value="item.postId" :label="item.postName" />
            </el-select>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增病症标签'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑病症标签'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

<script lang="js">
import { maladyLabelList, maladyLabelEdit, maladyLabelDelete, maladyLabelAdd } from "@/api/maladylabel"; // 病症标签请求
import { postList } from "@/api/post"; // 科室请求
export default {
  name: "MaladyLabel",
  data() {
    return {
      loading: true, // 加载中
      searchForm: { pathologyLabelName: null, postId: null }, // 查询表单
      postList: [], // 科室列表
      maladyLabelList: [], // 标签列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      multipleSelection: [], // 被选中行
      editFormRules: {
        pathologyLabelName: [{ required: true, message: "标签名称不能为空", trigger: "blur" }],
        postId: [{ required: true, message: "请选择标签所属科室", trigger: "change" }]
      }, // 验证规则
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    this.getPostList(); // 获取科室列表
    this.getLabelList(); // 获取标签列表
  },
  methods: {
    // 请求所有标签列表
    async getLabelList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await maladyLabelList(params);
      if (code == 200) {
        rows.forEach(item => {
          this.postList.forEach(items => {
            if (item.postId == items.postId) item.postName = items.postName;
          })
        })
        this.total = total;
        this.maladyLabelList = rows;
      }
      this.loading = false;
    },
    // 请求所有科室列表
    async getPostList() {
      let { code, rows } = await postList();
      if (code == 200) this.postList = rows;
    },
    // 新增标签
    addLabel() {
      this.dialogVisible = true;
      this.dialogTitle = "新增病症标签";
      this.editForm = { pathologyLabelName: null, postId: null };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          maladyLabelAdd(this.editForm).then(res => {
            if (res.code == 200) this.$message.success("新增病症标签成功！");
            this.dialogVisible = false;
            this.$refresh(this.getLabelList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 删除标签
    deleteLabel(row) {
      this.$confirm('确认删除该病症标签？').then(_ => { this.del(row.pathologyLabelId) }).catch(_ => { });
    },
    async del(id) {
      let { code } = await maladyLabelDelete(id);
      if (code == 200) this.$message.success("删除标签成功！");
      this.$refresh(this.getLabelList);
    },
    // 批量删除标签
    deleteLabelList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何病症标签");
      else {
        selected.forEach(item => { selectedId.push(item.pathologyLabelId) });
        this.$confirm('确认删除该病症标签？').then(_ => { this.del(selectedId) }).catch(_ => { });
      }
    },
    // 编辑标签信息
    editLabel(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogTitle = "编辑病症标签";
      this.dialogVisible = true;
    },
    // 保存标签修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          maladyLabelEdit(this.editForm).then(res => {
            if (res.code == 200) this.$message.success("修改标签成功！");
            this.dialogVisible = false;
            this.$refresh(this.getLabelList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    }
  },
};
</script>